// extracted by mini-css-extract-plugin
module.exports = {"container":"LeftMenu_container__3lSAm","header":"LeftMenu_header__10mTQ","logo":"LeftMenu_logo__3qJG3","logoSmall":"LeftMenu_logoSmall__1jKdW","trigger":"LeftMenu_trigger__1qMGa"};